export const fetch1 = async (api, body) => {
  // console.log(localStorage.getItem("token"));
  if (body) {
    let entries = Object.keys(body);
    let data = new FormData();
    for (let i = 0; i < entries.length; i++) {
      data.append(entries[i], body[entries[i]]);
    }
    const res = await fetch(api, {
      method: "post",
      headers: {
        Authorization: localStorage.getItem("care_admin_token"),
      },
      body: data,
    });
    return await res.json();
  }
};

export const fetch2 = async (api, body) => {
  // console.log(localStorage.getItem("token"));
  if (body) {
    let entries = Object.keys(body);
    let data = new FormData();
    for (let i = 0; i < entries.length; i++) {
      data.append(entries[i], body[entries[i]]);
    }
    const res = await fetch(api, {
      method: "post",
      headers: {
        Authorization: localStorage.getItem("superadmin_token"),
      },
      body: data,
    });
    return await res.json();
  }
};

export const fetch3 = async (api, type) => {
  // console.log(localStorage.getItem("token"));
  const res = await fetch(api, {
    method: type,
    headers: {
      Authorization: localStorage.getItem("care_admin_token"),
    },
  });
  return await res.json();
};

export const fetch4 = async (api, body, header = {}) => {
  try {
    if (body) {
      const res = await fetch(api, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...header,
        },
        body: JSON.stringify(body),
      });
      return await res.json();
    } else {
      const res = await fetch(`${process.env.REACT_APP_BASEURL}/${api}`, {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          ...header,
        },
      });
      return await res.json();
    }
  } catch (error) {
    return await error;
  }
};

export const deleteFetch = async (api, body, header = {}) => {
  try {
    if (body) {
      const res = await fetch(api, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          ...header,
        },
        body: JSON.stringify(body),
      });
      return await res.json();
    } else {
      const res = await fetch(`${process.env.REACT_APP_BASEURL}/${api}`, {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          ...header,
        },
      });
      return await res.json();
    }
  } catch (error) {
    return await error;
  }
};

export const httpRequest = async (api, method, body) => {
  try {
    const res = await fetch(`${process.env.REACT_APP_BASEURL}/${api}`, {
      method: method,
      headers: {
        "Content-Type": "application/json",
      },
    });
    return await res.json();
  } catch (error) {
    return await error;
  }
};

export const httpAdmin = async (api, method, body, dataType) => {
  try {
    // For login and other auth endpoints, use regular fetch
    const authEndpoints = ["login", "getNewToken", "authenticateCron"];
    const isAuthEndpoint = authEndpoints.some((endpoint) =>
      api.includes(endpoint)
    );

    if (isAuthEndpoint) {
      // Use regular fetch for auth endpoints
      let response;

      if (body && dataType === "formdata") {
        const res = await fetch(`${process.env.REACT_APP_BASEURL}/${api}`, {
          method: method,
          headers: {
            Authorization: localStorage.getItem("care_admin_token"),
          },
          body: body,
        });
        response = await res.json();
      } else if (body) {
        const res = await fetch(`${process.env.REACT_APP_BASEURL}/${api}`, {
          method: method,
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("care_admin_token"),
          },
          body: JSON.stringify(body),
        });
        response = await res.json();
      } else {
        const res = await fetch(`${process.env.REACT_APP_BASEURL}/${api}`, {
          method: method,
          headers: {
            Authorization: localStorage.getItem("care_admin_token"),
          },
        });
        response = await res.json();
      }

      // Check for Invalid Token response in auth endpoints
      const errMsg = response.message;
      if (
        response.status === false &&
        (errMsg?.includes("jwt expired") ||
          errMsg?.includes("Invalid Token") ||
          errMsg === "UNAUTHORIZED!")
      ) {
        const { handleLogoutAndRedirect } = await import(
          "../utils/logoutHandler"
        );
        handleLogoutAndRedirect();
      }

      return response;
    } else {
      // Use axios with interceptors for authenticated endpoints
      const { adminAxios } = await import("../utils/axiosInterceptor");
      let response;

      if (body && dataType === "formdata") {
        response = await adminAxios({
          method: method,
          url: `/${api}`,
          data: body,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      } else if (body) {
        response = await adminAxios({
          method: method,
          url: `/${api}`,
          data: body,
        });
      } else {
        response = await adminAxios({
          method: method,
          url: `/${api}`,
        });
      }

      // Check for Invalid Token response
      const resMsg = response.data?.message;
      if (
        response.data?.status === false &&
        (resMsg?.includes("jwt expired") || resMsg?.includes("Invalid Token"))
      ) {
        const { handleLogoutAndRedirect } = await import(
          "../utils/logoutHandler"
        );
        handleLogoutAndRedirect();
      }

      return response.data;
    }
  } catch (error) {
    const resMsg = error.response?.data?.message;
    // Check if the error response contains "Invalid Token"
    if (
      error.response?.data?.status === false &&
      (resMsg?.includes("jwt expired") || resMsg?.includes("Invalid Token"))
    ) {
      const { handleLogoutAndRedirect } = await import(
        "../utils/logoutHandler"
      );
      handleLogoutAndRedirect();
    }

    // Handle other errors
    if (error.response) {
      return (
        error.response.data || {
          status: false,
          message: "Something went wrong.",
        }
      );
    } else if (error.request) {
      return { status: false, message: "No response from server." };
    } else {
      return {
        status: false,
        message: error.message || "Something went wrong.",
      };
    }
  }
};

export const httpPortal = async (api, method, body, dataType) => {
  try {
    // For login and other auth endpoints, use regular fetch
    const authEndpoints = [
      "login",
      "createPassword",
      "authenticateCron",
      "checkSecurityQuestions",
    ];
    const isAuthEndpoint =
      authEndpoints.some((endpoint) => api.includes(endpoint)) ||
      dataType === "withoutToken";

    if (isAuthEndpoint) {
      // Use regular fetch for auth endpoints
      if (body && dataType === "formdata") {
        const res = await fetch(`${process.env.REACT_APP_fANDF}/${api}`, {
          method: method,
          headers: {
            Authorization: localStorage.getItem("fandfam_token"),
          },
          body: body,
        });
        return await res.json();
      } else if (body && dataType === "json") {
        const res = await fetch(`${process.env.REACT_APP_fANDF}/${api}`, {
          method: method,
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("fandfam_token"),
          },
          body: body,
        });
        return await res.json();
      } else if (body && dataType === "withoutToken") {
        const res = await fetch(`${process.env.REACT_APP_fANDF}/${api}`, {
          method: method,
          headers: {
            "Content-Type": "application/json",
          },
          body: body,
        });
        return await res.json();
      } else if (dataType === "withoutToken") {
        const res = await fetch(`${process.env.REACT_APP_fANDF}/${api}`, {
          method: "get",
          headers: {
            "Content-Type": "application/json",
          },
        });
        return await res.json();
      } else {
        const res = await fetch(`${process.env.REACT_APP_fANDF}/${api}`, {
          method: method,
          headers: {
            Authorization: localStorage.getItem("fandfam_token"),
          },
        });
        return await res.json();
      }
    } else {
      // Use axios with interceptors for authenticated endpoints
      const { portalAxios } = await import("../utils/portalAxiosInterceptor");
      let response;

      if (body && dataType === "formdata") {
        response = await portalAxios({
          method: method,
          url: `/${api}`,
          data: body,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      } else if (body) {
        response = await portalAxios({
          method: method,
          url: `/${api}`,
          data: body,
        });
      } else {
        response = await portalAxios({
          method: method,
          url: `/${api}`,
        });
      }

      // Check for Invalid Token response
      const resMsg = response.data?.message;
      if (
        response.data?.status === false &&
        (resMsg?.includes("jwt expired") || resMsg?.includes("Invalid Token"))
      ) {
        const { handlePortalLogoutAndRedirect } = await import(
          "../utils/portalTokenRefresh"
        );
        handlePortalLogoutAndRedirect();
      }

      return response.data;
    }
  } catch (error) {
    // Check if the error response contains "Invalid Token"
    const resMsg = error.response?.data?.message;
    if (
      error.response?.data?.status === false &&
      (resMsg?.includes("jwt expired") || resMsg?.includes("Invalid Token"))
    ) {
      const { handlePortalLogoutAndRedirect } = await import(
        "../utils/portalTokenRefresh"
      );
      handlePortalLogoutAndRedirect();
    }

    // Handle other errors
    if (error.response) {
      return (
        error.response.data || {
          status: false,
          message: "Something went wrong.",
        }
      );
    } else if (error.request) {
      return { status: false, message: "No response from server." };
    } else {
      return {
        status: false,
        message: error.message || "Something went wrong.",
      };
    }
  }
};

export const httpSuperAdmin = async (api, body, dataType = "json") => {
  try {
    // Dynamically import superadminAxios to use interceptors
    const { superadminAxios } = await import(
      "../utils/superadminAxiosInterceptor"
    );
    let response;

    if (body && dataType === "formdata") {
      response = await superadminAxios.post(`/${api}`, body, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    } else if (body) {
      response = await superadminAxios.post(`/${api}`, body);
    } else {
      response = await superadminAxios.get(`/${api}`);
    }

    // Check for Invalid Token response
    const resMsg = response.data?.message;
    if (
      response.data?.status === false &&
      (resMsg?.includes("jwt expired") || resMsg?.includes("Invalid Token"))
    ) {
      const { handleSuperadminLogoutAndRedirect } = await import(
        "../utils/superadminTokenRefresh"
      );
      handleSuperadminLogoutAndRedirect();
    }

    return response.data;
  } catch (error) {
    // Check if the error response contains "Invalid Token"
    const resMsg = error.response?.data?.message;
    if (
      error.response?.data?.status === false &&
      (resMsg?.includes("jwt expired") || resMsg?.includes("Invalid Token"))
    ) {
      const { handleSuperadminLogoutAndRedirect } = await import(
        "../utils/superadminTokenRefresh"
      );
      handleSuperadminLogoutAndRedirect();
    }

    // Handle other axios errors
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      return (
        error.response.data || {
          status: false,
          message: "Something went wrong.",
        }
      );
    } else if (error.request) {
      // The request was made but no response was received
      return { status: false, message: "No response from server." };
    } else {
      // Something happened in setting up the request that triggered an Error
      return {
        status: false,
        message: error.message || "Something went wrong.",
      };
    }
  }
};

export const httpPayments = async (api, body) => {
  let token = localStorage.getItem("care_admin_token");
  if (!token) token = localStorage.getItem("careAdminToken");
  try {
    if (body) {
      const res = await fetch(`${process.env.REACT_APP_BASEURL}/${api}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(body),
      });
      return await res.json();
    } else {
      const res = await fetch(`${process.env.REACT_APP_BASEURL}/${api}`, {
        method: "get",
        headers: {
          Authorization: token,
        },
      });
      return await res.json();
    }
  } catch (error) {
    return await error;
  }
};

// this function is for no token

export const httpCareMagnus = async (api, body) => {
  try {
    if (body) {
      const res = await fetch(
        `${process.env.REACT_APP_SUPERADMIN_BASEURL}/${api}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        }
      );
      return await res.json();
    } else {
      const res = await fetch(
        `${process.env.REACT_APP_SUPERADMIN_BASEURL}/${api}`,
        {
          method: "get",
        }
      );
      return await res.json();
    }
  } catch (error) {
    return await error;
  }
};

export function limitToTwoDecimal(number) {
  return Math.round(number * 100) / 100;
}

export function sortByDateDescend(dataArray, dateProperty) {
  return dataArray.sort(
    (a, b) => new Date(b[dateProperty]) - new Date(a[dateProperty])
  );
}

export function combineDateTimeAndTimeZone(dateString, timeString, timeZone) {
  const usertimeZone =
    timeZone ?? Intl.DateTimeFormat().resolvedOptions().timeZone;
  const dateTimeString = `${dateString} ${timeString || "00:00"}:00`;
  const combinedDateTime = new Date(dateTimeString + usertimeZone);
  console.log(combinedDateTime, "combinedDateTime");

  return combinedDateTime;
}
